<template>
  <div id="app" style="padding: 0px 0px">
    <a id="app-download-link" class="d-none" download />
    <v-app>
      <AppProgress />
      <CommonHeader />
      <AppNotification />
      <NotificationQueue v-if="showNotificationQueue" />
      <AppNavigation />
      <UpdateChecker :intervalMin="updateInterval" />
      <v-main
        id="main-container"
        class="pb-10"
        :class="{ 'hide-overflow': navigation }"
      >
        <v-btn
          :title="$t('Часто задаваемые вопросы')"
          href="/faq"
          small
          :large="$vuetify.breakpoint.mdAndUp"
          fab
          dark
          color="primary"
          fixed
          class="fab-question"
        >
          <v-icon>{{ helpIcon }}</v-icon>
        </v-btn>
        <CabinetHeader v-if="showHeader" />
        <router-view></router-view>
      </v-main>
      <AppFooter />
    </v-app>
  </div>
</template>

<script lang="ts">
import CommonHeader from "@/components/layout/CommonHeader.vue";
import CabinetHeader from "@/components/layout/CabinetHeader.vue";
import AppNotification from "@/components/layout/AppNotification.vue";
import AppNavigation from "@/components/layout/AppNavigation.vue";
import NotificationQueue from "@/components/notifications/NotificationsQueue.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import AppProgress from "@/components/layout/AppProgress.vue";
import baseModule from "./store/base.module";
import { Component, Vue, Watch } from "vue-property-decorator";
import { mdiHelp } from "@mdi/js";
import mailModule from "./store/mail.module";
import UpdateChecker from "@/components/ui/UpdateChecker.vue";
import authModule from "./store/auth.module";

@Component({
  name: "App",
  components: {
    CommonHeader,
    CabinetHeader,
    AppNotification,
    NotificationQueue,
    AppFooter,
    AppNavigation,
    AppProgress,
    UpdateChecker,
  },
})
export default class extends Vue {
  get navigation() {
    return baseModule.navigation;
  }

  get helpIcon() {
    return mdiHelp;
  }

  get updateInterval() {
    return Number(process.env.VUE_APP_UPDATE_CHECKER_INTERVAL_MINUTE || "5");
  }

  get showHeader() {
    return baseModule.showHeader;
  }

  @Watch("$route.path")
  async handlePathChange() {
    if (authModule.loggedIn) mailModule.getNotificationsCount();
  }
  // created() {
  //   mailModule.getNotificationsCount();

  //   statementModule.statements.options.vuetifyTableOptions.page = 1;
  //   statementModule.statements.options.vuetifyTableOptions.itemsPerPage = 5;
  // }

  beforeDestroy() {
    mailModule.setNotificationsCount({});
  }

  get showNotificationQueue() {
    return authModule.loggedIn && !authModule.isEmployer;
  }
}
</script>
<style lang="scss">
@import "~vuetify/src/styles/styles.sass";
.hide-overflow {
  max-height: 80vh !important;
  overflow: hidden;
}
.page-title {
  @include fontSize(20, 24);
  color: var(--v-primary-base);
  margin-bottom: 40px;
}

.field-hint {
  @include fontSize(12, 20);
}

.page-info {
  a {
    text-decoration: underline;
  }
  @include fontSize(10, 16);
}

.px {
  padding-right: 120px;
  padding-left: 70px;
}

.py {
  padding-top: 30px;
}

.fab-question {
  right: 72px;
  bottom: 5px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .px {
    padding-right: 14px;
    padding-left: 14px;
  }

  .py {
    padding-top: 20px;
  }

  .page-title {
    margin-bottom: 16px;
  }

  .fab-question {
    right: 14px;
    bottom: 5px;
  }
}
</style>
